<template>
	<div class="content">
		<div class="content_head">
			<button type="button" @click="$router.go(-1)" class="button">返回</button>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>账号</th>
						<th>姓名</th>
						<th>类型</th>
						<th>登录店铺</th>
						<th>登录时间</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in loginRecord">
						<td>
							{{index+1}}
						</td>
						<td>
							{{i.UserAccount}}
						</td>
						<td>
							{{i.UserName}}
						</td>
						<td>
							{{i.UserType |UserType}}
						</td>
						<td>
							{{i.ShopName}}
						</td>
						<td>
							{{i.LoginDate}}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			<button class="button" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>
			<select v-model="pageRows" @change="changePageRows">
				<option value="10">10/页</option>
				<option value="20">20/页</option>
				<option value="30">30/页</option>
			</select>
			<button class="button" :disabled="down" @click="changePages('down')">下一页</button>
		</div>
	</div>


</template>

<script>
	export default {
		name: 'signInHistoryDetail',
		data() {
			return {
				getData: {},
				UserID: 0,
				loginRecord: [],
				pageIndex: 1,
				pageRows: 10,
				count: 0
			};
		},
		created() {
			
			this.getData = function() {
				this.UserID = this.$route.params.userID;
				this.$request.request({
					url: 'login/getSignInHistory',
					data: {
						pageCount: this.pageRows,
						UserID: this.UserID,
						pageIndex: this.pageIndex
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.loginRecord = res.loginRecord;
						this.count = res.count;
					}
				});
			}
			this.getData();

		},
		methods: {
			changePages(s) {
				if (s == 'up') {
					if (this.pageIndex == 1)
						return;
					else
						this.pageIndex--;

				} else {
					if (this.pageIndex * this.pageRows >= this.count)
						return;
					else
						this.pageIndex++;
				}

				this.getData();
			},
			changePageRows() {
				if (this.pageIndex * this.pageRows >= this.count)
					this.pageIndex = 1;
				this.getData();
			}
		},
		computed: {
			up() {
				if (this.pageIndex == 1)
					return true;
				else
					return false;
			},
			down() {
				if (this.pageIndex * this.pageRows >= this.count)
					return true;
				else
					return false;
			},
			page() {
				if (Math.ceil((this.count / this.pageRows)) == 0)
					return this.pageIndex + '/' + 1 + '页';
				else
					return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
			}

		},
		filters: {
			UserType(v) {
				if (v == '0') return '管理员';
				if (v == '1') return '店长';
				if (v == '2') return '店员';
				if (v == '3') return '派送员';
			}
		},
		watch: {
			$route(n, o) { 
				if (n.path.indexOf('signInHistoryDetail') == -1) return;
				let nbooksid = n.params.userID;
				let obooksid = o.params.userID;
				if (nbooksid != obooksid)
					this.getData();
			}
		
		}

	}
</script>

<style>
</style>
